import Vue from 'vue'
import VueRouter from 'vue-router'
// speciális, a belső componentek használ(hat)ják az ebben lévő styleokat, ezért ezt kötelezőp behuzni, nem csak mikor oda lepünk..
import { loadLanguageAsync, i18n } from '../i18n-setup/i18n-setup.js'
import Axios from 'axios'
import routeList from '../router/routeList.js'
import testerRouteList from '../router/testerRouteList.js'

Vue.use(VueRouter)

/**
 * scrollBehavior() route váltáskor felscrollozunk a lap tetejére, különben ha átnavigálunk egy oldalra ugy hogy a lap alján volt a link akkor ott is alul leszünk default
 *
 * @type {VueRouter}
 */
const router = new VueRouter({
  mode: 'history',
  routes: window.isTesterPage ? testerRouteList : routeList, // short for `routes: routes`
  scrollBehavior(to, from, savedPosition) {
    // csak vue oldalon legyen router pushnál scroll, egyébként ne
    if (to.matched.length > 0 && to.name !== '') {
      return {
        // ha az kell hogy oda scrollozzunk ahol voltunk legutobb
        /* x: savedPosition ? savedPosition.x : 0,
        y: savedPosition ? savedPosition.y : 0, */
        x: 0,
        y: 0,
        behavior: 'smooth',
      }
    }
  },
})

/**
 * legutobb beküldött Title
 *
 * @type {null|String}
 */
window.latestTitle = null

/**
 * title változott, ha igen akkor kell route change után pageView
 *
 * @type {boolean}
 */
window.needPageViewEventAfterRouting = false

/**
 * route változott, ha a title is változik kell pageView
 *
 * @type {boolean}
 */
window.isAfterRouting = false

// select the target node
const target = document.querySelector('title')

// configuration of the observer:
const config = {
  subtree: true,
  characterData: true,
  childList: true,
}

// Itt figyeljük a title változását, ha változott akkor pageView eventet kell beküldeni
const observer = new MutationObserver(function (mutations) {
  if (mutations[0].addedNodes[0].data !== window.latestTitle) {
    window.latestTitle = mutations[0].addedNodes[0].data
    // ha már volt route akkor ajax után jött a title, mostmár mehet a pageView
    if (window.isAfterRouting) {
      Axios.post('/Shop/api/pageView', {
        pageName: router.app.$route.name,
        id: 'id' in router.app.$route.params ? router.app.$route.params.id : null,
      })
      window.dataLayerViewPage()
      window.isAfterRouting = false
    } else {
      // még nem volt route change, route change után mehet a pageView
      window.needPageViewEventAfterRouting = true
    }
  }
})
observer.observe(target, config)

window.routeHistory = []

router.afterEach((to, from) => {
  if (to.name === null || window.is404) {
    // ha nem vue a page content akkor eltüntetjük a vue breadcrumbot
    router.app.$root.$emit('breadcrumbChange', {
      pageName: '',
    })
  } else if (to.meta.changeBreadCrumb) {
    const breadCrumbData = { ...to.meta.breadCrumbData }
    if (breadCrumbData.needInstance) {
      breadCrumbData.node = to.params.id
    }
    router.app.$root.$emit('breadcrumbChange', breadCrumbData)
  }
  // bezárjuk a menüt és eltüntetjük a 404-et
  if (!window.is404 && !notFoundPageList.includes(to.fullPath)) {
    router.app.$root.$emit('hideNotFoundPage')
  }
  window.is404 = false
  router.app.$root.$emit('closeCart')
  router.app.$root.$emit('closeSearch')
  router.app.$root.$emit('closeMegaMenu')
  // már volt title change, mostmár a route is változott, mehet a pageView
  if (window.needPageViewEventAfterRouting) {
    Axios.post('Shop/api/pageView', {
      pageName: to.name,
      id: 'id' in to.params ? to.params.id : null,
    })
    window.dataLayerViewPage()
    window.needPageViewEventAfterRouting = false
  } else {
    // route már változott, title még nem változott, ha az is megvolt mehet a pageView
    window.isAfterRouting = true
  }
  window.removeLoader()
  window.routeHistory.push(from.fullPath + ' -> ' + to.fullPath)
})

/**
 * 404 oldalak url listája
 *
 * @type {*[]}
 */
const notFoundPageList = []

router.beforeEach((to, from, next) => {
  /*
   * ha vue page-ről navigálunk egy olyan page-re amire nincs match,
   * akkor ráfrissítünk, hogy a a redirect tábla lefusson és csinálja amit kell
   * ez kb csak akkor lehet új designban hogyha nem megfelelő linket használnak cikkekben
   * amire redirect táblából lesz meg hova kellene menni
   */
  if (!to.name && from.name !== null) {
    window.location.href = to.fullPath
  }
  // mivel nem minden page Vue ezért ha nem vue pageről megyünk Vue-ra majd visza, akkor a document title maradna az ami vue-n volt. de visszarakjuk arra ami volt előtte
  if (!to.name && !window.is404) {
    window.location.href = to.fullPath
  }
  /**
   * Az apiról lekért fordításokat beállítja az i18n-nek
   */
  loadLanguageAsync(window.domainLang)
    .then(() => {
      if (window.is404) {
        router.app.$root.$emit('showNotFoundPage')
        // ha 404 oldal, akkor elmentjük hogy az volt, és ha routerrel lépünk vissza, akkor megsem próbáljuk betölteni
        if (!notFoundPageList.includes(to.fullPath)) {
          notFoundPageList.push(to.fullPath)
        }
      }
      router.app.$store.dispatch('Site/setIsTranslationsInitDone', true)
      if (notFoundPageList.includes(to.fullPath)) {
        router.app.$root.$emit('showNotFoundPage')
      }
      if (to.meta.title !== undefined) {
        document.title = getTitleFromPath(to.path)
      }
      // megprobáljuk lekérni a usert
      router.app.$store.dispatch('User/getActiveUser')
        .then(() => {
          // ha protected a route, és nincs belépve
          if (to.meta.protectedRoute) {
            // ha még igy sincs login akkor megyünk a loginra
            if (!router.app.$store.getters['User/isLoggedIn']) {
              if (from.name !== 'login') {
                Axios.post('Shop/api/setReturnUrl', {
                  returnUrl: from.fullPath,
                })
                next({
                  name: 'login',
                })
              }
              next(false)
            } else {
              // amugy ahova akartunk
              next()
            }
          } else {
            // ha olyan pagere tévedünk belogolva, ami csak kilogolva érhető el, itt elintézzük a redirt, ne komponensenként kelljen..
            if (to.meta.onlyLoggedOut && router.app.$store.getters['User/isLoggedIn']) {
              next({
                path: to.meta.redirectLoggedIn,
              })
            } else {
              if (to.name === 'login') {
                Axios.post('Shop/api/setReturnUrl', {
                  returnUrl: from.fullPath,
                })
              }
              next()
            }
          }
        })
        .catch((err) => {
          console.error(err)
        })
    })
    .catch((e) => {
      console.error(e)
    })
})

/**
 * innen tudjuk majd path alapján melyik title i18n menjen
 *
 * @param path
 * @returns {string}
 */
function getTitleFromPath(path) {
  // default ami volt
  let title = document.title
  switch (path) {
    case '/profile':
      title = i18n.t('profilom')
      break
    case '/helpdesk':
      title = i18n.t('helpdesk_title::odal_headertag')
      break
    case '/checkout':
      title = i18n.t('rendel_title::odal_headertag')
      break
    case '/search':
      if (router.app.$store.getters['Site/isSiteLoadDone']) {
        title = router.app.$store.getters['Site/getSiteName'] + ' ' + i18n.t('search_title::odal_headertag')
      } else {
        /*
         * még nincs site betöltve -> refresh volt a kereső oldalon,
         * ilyenkor az og:title megegyezik azzal ami a title kellene legyen,
         * az pedig be van állítva a SEO miatt renderkor, annak vesszük ki az értékét
         */
        title = document.querySelector('meta[property="og:title"]').content
      }
      break
    case '/thank_you':
      title = i18n.t('rendel_visszaigazolas_title')
      break
    case '/login':
      title = i18n.t('login::odal_headertag')
      break
    case '/passwordRecovery':
      title = i18n.t('jelszoemlekezteto')
      break
    case '/changePassword':
      title = i18n.t('set_new_password_title')
      break
    case '/returnClothing':
      title = i18n.t('return_clothing::odal_headertag')
      break
  }
  return title
}

export default router
